import type { FaireProductEntity } from "../../entity_types/product";

export const p_t27bzhu6dg: FaireProductEntity = {
  token: "p_t27bzhu6dg",
  type: "product",
  name: "Gold Chunky Flat Clicker Hoop Earrings",
  brandToken: "b_q2rp7x96kv",
  brandName: "GoldFi",
  imageUrl:
    "https://cdn.faire.com/fastly/05f71a3827f983ee70643da1299cc96b9c3b35229a5336473ae2c72982ecb34c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fac79f7532068fce9b4bc3a85d462994cbfbe78e75c8aea1d94d5e85294c5be1.jpeg",
    "https://cdn.faire.com/fastly/7d5644686a29ca82d03400845bc863e6186a3de720097773b04002e23d7e5566.jpeg",
    "https://cdn.faire.com/fastly/6f8fef6082847b2a58e6945e4a8759b32b0932f9c88c3b9b7d6910d49c80ad8c.jpeg",
    "https://cdn.faire.com/fastly/43335c88303645f8f5d35d4e9bebc03de63d0580df4c35f6692f15569b54e3d8.jpeg",
  ],
  priceDollars: 16.76,
  description:
    "Daily mini huggies for your wardrobe foundational basics. You will keep this gorgeous hoops on rotation. They're polished and easy with high-impact shine. That is exactly what you were looking for.\n\n * Metal: 18k gold-filled \n * Size: 7mm wide x 13mm external diameter \n * Hypoallergenic and waterproof \n * Made in Brazil ",
  tags: [],
  msrpDollars: 41.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:47.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
